import http from '@/http'
import config from '@/config'

const mediaToLdReference = (media) => {
	if (media == null) return undefined
	if (typeof media === 'string') return media
	if (typeof media !== 'object') return undefined
	if (media['@id']) return media['@id']
	if (media.id != null && media.id !== '') {
		const base = (config.service.apiURL || '').replace(/\/$/, '')
		return `${base}/media_objects/${media.id}`
	}
	return undefined
}

const normalizeRouteAttachmentPayload = (att) => {
	if (!att) return null
	const mediaRef = mediaToLdReference(att.media)
	const base = {
		description: att.description != null ? att.description : '',
		...(mediaRef != null ? { media: mediaRef } : {})
	}
	if (att['@id']) {
		return { '@id': att['@id'], ...base }
	}
	if (att.id != null && att.id !== '') {
		const baseUrl = (config.service.apiURL || '').replace(/\/$/, '')
		return { '@id': `${baseUrl}/route_attachments/${att.id}`, ...base }
	}
	return base
}

const find = id => {
	const path = `routes/${encodeURIComponent(id)}`
	return http.get(path)
}

const getAll = ({ field, order }, perPage = 10, pageNr = 1, filter, searchText) => {
	let filterSegment = ''
	let searchSegment = ''

	if (filter) {
		if (typeof filter.value === 'boolean')
			filterSegment += `&${filter.by}[exists]=${filter.value}`
		else if (Array.isArray(filter.value))
			filter.value.forEach(value => {
				filterSegment += `&${filter.by}[]=${value}`
			})
		else filterSegment += `&${filter.by}=${filter.value}`
	}

	if (searchText) searchSegment = `&search=${searchText}`

	const path = `routes?order[${field}]=${order}&itemsPerPage=${perPage}&page=${pageNr}${filterSegment}${searchSegment}`
	return http.get(path)
}

const update = route => {
	const path = `routes/${route.id}`

	const routeToSave = { ...route }
	if (routeToSave.orders) delete routeToSave.orders
	if (routeToSave.routePoints) delete routeToSave.routePoints
	if (routeToSave.ordersDistances) delete routeToSave.ordersDistances
	if (route.creator) delete routeToSave.creator

	if (Object.prototype.hasOwnProperty.call(route, 'routeAttachment')) {
		routeToSave.routeAttachment = normalizeRouteAttachmentPayload(route.routeAttachment)
	}

	return http.put(path, routeToSave)
}

const create = route => {
	const path = `routes`
	if (route.creator) delete route.creator
	return http.post(path, route)
}

const planRoute = payload => {
	const path = `routes/plan`
	return http.post(path, payload, {
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json'
		}
	})
}

const updatePlan = (routeId, payload) => {
	const path = `routes/${routeId}/plan`
	return http.put(path, payload, {
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json'
		}
	})
}

const recalculate = routeId => {
	const path = `routes/${routeId}/recalculate`
	return http.post(path, {}, {
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json'
		}
	})
}

const destroy = route => {
	const path = `routes/${route.id}`
	return http.delete(path)
}

export default {
	find,
	getAll,
	update,
	create,
	planRoute,
	updatePlan,
	recalculate,
	destroy
}
